import { queryOptions } from '@tanstack/react-query'

import type { RequestQueryOptions } from '../model'
import { getLatestPenaltyWaiverAction } from './penalty-waiver.action'

export type LatestPenaltyWaiverData = {
  id: string
  classId: number
  eventType: 'CANCEL' | 'NOSHOW'
  utcCreatedAt: string
}

export const latestPenaltyWaiverQueryOptions = ({
  bearerToken,
  eventType,
}: RequestQueryOptions<{ eventType: 'CANCEL' | 'NOSHOW' }>) =>
  queryOptions<LatestPenaltyWaiverData | null>({
    queryKey: ['lesson', 'latestPenaltyWaiver', bearerToken, eventType] as const,
    queryFn: () => getLatestPenaltyWaiverAction(eventType, bearerToken),
  })
